import PropTypes from 'prop-types';

import FormModal from '#client/components/FormModal';

import FreezeCardForm from './FreezeCardForm';

export default function FreezeCardModal({ handleClose }) {
  return (
    <FormModal handleClose={handleClose}>
      <FreezeCardForm handleClose={handleClose} />
    </FormModal>
  );
}

FreezeCardModal.propTypes = {
  handleClose: PropTypes.func.isRequired
};
